export enum fileTabVal {
    DETAILS = "details",
    WORKSPACE = "workspace",
    DOCUMENTS = "docs",
    CLIENTPORTAL = "clientportal",
    EMPTY = ""
}

export type WritSearchType = {
    date: Date,
}

export type TitleSearchType = {
    date: Date,
}

export enum CONST {
    uninitialized = "uninit"
}

export type IndicatorBadgeType = {
    type: string,
    label: string,
    category:string,
}

export type TitleInsuranceType = {
    insuranceProvider : string,
}

export type MortgageType = {
    Lender: string,
    PSM: string,
    registrationDate: string,
    instrumentNumber: string,
    position: string,
    type: "New" | "VTB" | "Discharge" | "Assumed" | "Remaining" | "Postpone",
}
export type PersonType = {
    Name: string,
    personType: string,
    OtherPartyType?: string,
}

export type RegistrationType = {
    Name: string,
    label: string,
}

export type FinanceType = {
    adjustment: {
        bdoc: Number,
    },
    account: {
        owing: Number,
    }
    trust: {
        buyer: Number,
    }
}

export type PurchaserType = {
   Name: string,
   IsPurchaser: string,
   OnTitle: string,
   personType: string,
   AddressForService: string,
   TransfereeNameFull: string,
}

export type ContractType = {
   closingDate: Date,
   propertyAddress: string,
}

export type VendorType = {
   Name: string,
   IsVendor: string,
   OnTitle: string,
   personType: string,
   TransferorNameFull: string,
}

export type GuarantorType = {
    Name: string, 
}

export type PriorOwnerType = {
    Name: string,
}